export default "__VITE_ASSET__C27idv____"